import React from 'react';

export default function LexPage() {
  return (
    <div className='App-block'>
      <p className='Lex-list-info'>TL;DR: Ole kiltti muita kohtaan.</p>

      <p className='Lex-list'>
      <p className='Lex-list-warning'>Pulinassa ei ketään rajoiteta, eikä valvota.</p>
      <p className='Lex-list-warning'>Omalla vastuulla, omaa järkeä käyttäen.</p>
        <ul>
          <li>Ei huijauksia</li>
          <li>Ei haukuta toisia</li>
          <li>Ei kiusata ketään</li>
          <li>Ei pornografiaa</li>
          <li>Ei uhkailua</li>
        </ul>
      </p>
      <p className='Lex-list-warning'>Sääntöjen rikkominen voi johtaa poistamiseen.</p>
      <p className='Lex-list-warning'>Huomio: Pulina on alkuvaiheessa ja säännöt voivat muuttua ajan saatossa.</p>
    </div>
  );
}

